package br.com.htms.inspeccaocampo.export

/** Leitura mínima de ZIP (.xlsx): diretório central + entradas STORE ou DEFLATE. */
object ZipLeitor {
    class Entrada(val metodo: Int, val offsetLocal: Int, val tamanho: Int)

    private fun u16(b: ByteArray, o: Int) = (b[o].toInt() and 0xFF) or ((b[o + 1].toInt() and 0xFF) shl 8)
    private fun u32(b: ByteArray, o: Int) = u16(b, o) or (u16(b, o + 2) shl 16)

    fun indice(b: ByteArray): Map<String, Entrada> {
        var eocd = -1
        var i = b.size - 22
        val limite = maxOf(0, b.size - 22 - 65535)
        while (i >= limite) {
            if (u32(b, i) == 0x06054b50) { eocd = i; break }
            i--
        }
        if (eocd < 0) error("Arquivo .xlsx inválido ou corrompido.")
        val total = u16(b, eocd + 10)
        var p = u32(b, eocd + 16)
        val mapa = LinkedHashMap<String, Entrada>()
        repeat(total) {
            if (p + 46 > b.size || u32(b, p) != 0x02014b50) error("Arquivo .xlsx inválido ou corrompido.")
            val metodo = u16(b, p + 10)
            val comp = u32(b, p + 20)
            val nLen = u16(b, p + 28)
            val eLen = u16(b, p + 30)
            val cLen = u16(b, p + 32)
            val local = u32(b, p + 42)
            val nome = b.copyOfRange(p + 46, p + 46 + nLen).decodeToString()
            mapa[nome] = Entrada(metodo, local, comp)
            p += 46 + nLen + eLen + cLen
        }
        return mapa
    }

    private fun dados(b: ByteArray, e: Entrada): ByteArray {
        val o = e.offsetLocal
        val inicio = o + 30 + u16(b, o + 26) + u16(b, o + 28)
        return b.copyOfRange(inicio, inicio + e.tamanho)
    }

    suspend fun ler(b: ByteArray, e: Entrada, inflate: suspend (ByteArray) -> ByteArray?): ByteArray =
        when (e.metodo) {
            0 -> dados(b, e)
            8 -> inflate(dados(b, e)) ?: error("Este dispositivo não conseguiu abrir o .xlsx. Salve como .csv e tente de novo.")
            else -> error("Compressão do .xlsx não suportada. Salve como .csv e tente de novo.")
        }

    /** Todas as entradas de um ZIP sem compressão (modelos gerados pelo próprio projeto). */
    fun lerSemCompressao(b: ByteArray): LinkedHashMap<String, ByteArray> {
        val out = LinkedHashMap<String, ByteArray>()
        indice(b).forEach { (nome, e) ->
            require(e.metodo == 0) { "Modelo compactado: gere o asset com ZIP_STORED ($nome)." }
            out[nome] = dados(b, e)
        }
        return out
    }
}
